import { render, staticRenderFns } from "./waitingSubmit.vue?vue&type=template&id=6680b344&scoped=true"
import script from "./waitingSubmit.vue?vue&type=script&lang=js"
export * from "./waitingSubmit.vue?vue&type=script&lang=js"
import style0 from "./waitingSubmit.vue?vue&type=style&index=0&id=6680b344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6680b344",
  null
  
)

export default component.exports